module.exports = __webpack_public_path__ + "static/media/icon-drone.032dcc11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-drone.svg
// module id = 554
// module chunks = 0